<div class="dvat-inactivity-message">
  <div class="dvat-inactivity-message__body">
    <div class="dvat-inactivity-timer__circle" aria-live="polite" aria-label="Resterende tijd: {{ formattedTime }}">
      {{ formattedTime }}
    </div>
    <h6 class="dvat-inactivity-message__title">Ben je er nog?</h6>
    <p class="dvat-inactivity-message__warning">Als je binnen 5 minuten geen bericht stuurt, wordt het gesprek beeïndigd.</p>
  </div>
</div>
